import { debounce } from '@/ui/util';
import { identity } from '@fxts/core';

export interface PostMessageNavigate {
  navigate: {
    name:
      | 'Home'
      | 'Popup'
      | 'Creator'
      | 'Shop'
      | 'EmptyScreen'
      | 'SubScreen'
      | 'UtilScreen'
      | 'SignUpSeller'
      | 'SettingScreen'
      | 'Cart'
      | 'SellerStudioScreen';
    params?: {
      uri?: string;
      // 해당 키를 추가하면 앱 상에서 해당 키를 가진 스크린으로 이동합니다.
      override_key?: string;
    };
  };
}

export interface PostMessageResetNavigate {
  resetNavigate: {
    sel: `TabNavigation.HomeStack.${'Home' | 'Popup' | 'Creator' | 'Shop' | 'Mypage'}`;
    params?: {
      uri?: string;
    };
  };
}

export interface PostMessageCommon {
  goBack?: true;
  logout?: true;
  type?: string;
}

const postMessage = debounce((data: PostMessageNavigate | PostMessageCommon | PostMessageResetNavigate) => {
  if (
    window.ReactNativeWebView &&
    window.MauthApp?.props.sharedData.is_app &&
    window.MauthApp?.props.sharedData.app_info?.name !== 'Marpple'
  ) {
    window.ReactNativeWebView.postMessage(JSON.stringify(data));
  }
}, 200);

const goBack = () => {
  postMessage({ goBack: true }).catch(identity);
};

const goHome = () => {
  postMessage({ navigate: { name: 'Home' } }).catch(identity);
};
const resetHome = () => {
  postMessage({ resetNavigate: { sel: 'TabNavigation.HomeStack.Home' } }).catch(identity);
};
const resetMypage = () => {
  postMessage({ resetNavigate: { sel: 'TabNavigation.HomeStack.Mypage' } }).catch(identity);
};
const goEmptyScreen = (params: { uri: string; override_key?: string }) => {
  postMessage({ navigate: { name: 'EmptyScreen', params } }).catch(identity);
};

const goSubScreen = (params: { uri: string }) => {
  postMessage({ navigate: { name: 'SubScreen', params } }).catch(identity);
};

const logout = () => {
  postMessage({ logout: true }).catch(identity);
};

const myPageDirty = () => {
  postMessage({ type: 'mypage:dirty' }).catch(identity);
};

const myPageClean = () => {
  postMessage({ type: 'mypage:clean' }).catch(identity);
};

const withdraw = () => {
  postMessage({ type: 'user:withdraw' }).catch(identity);
};

export const PostMessage = {
  logout,
  goBack,
  goHome,
  goEmptyScreen,
  goSubScreen,
  resetHome,
  resetMypage,
  myPageDirty,
  myPageClean,
  withdraw,
};
